<template>
  <div class="dish-desc-body" v-if="!editMode">
    <img :src="(dish.image || dish.image_thumbnail ? dish.image_thumbnail || dish.image : '/icons/no-dish.png')+`?nonce=${cache_nonce || Date.now()}`" alt />
    <div class="space-scroll">
      <div class="dish-card-scroll">
        <div class="dish-info position-relative">
          <div class="dish-name-header">
            <h2 :class="dish.prices.length == 1 ? 'w-75' : ''">
              {{
                isLocalizing && currentProductLocale.name
                  ? currentProductLocale.name
                  : dish.name
              }}
            </h2>
            <p class="price" v-if="onlySinglePrice && dish.base_price">
              {{ dish.base_price }}{{ currency.symbol }}
            </p>
          </div>
          <p class="about-dish" v-html="breakedDescription"></p>
          <!-- <p
            class="about-dish"
            v-if="dish.ingredients && dish.ingredients.length"
          >{{ $t('menu_settings.ingredients') }}: {{ dish.ingredients.join(', ') }}</p> -->
          <p class="about-dish" v-if="onlySinglePrice && dish.base_weight">
            {{ dish.unit == "g" || dish.unit == 'kg' ? $t('menu_settings.weight') : $t('menu_settings.volume') }}: {{ dish.base_weight }}
            {{ $t(`units.${dish.unit}`) }}
          </p>
        </div>
        <div v-if="dish.price_groups.length">
          <div v-for="(group, index) in dish.price_groups" :key="index">
            <div class="dish-variants" v-if="group.single_select">
              <h3 class="extra-title">
                {{ group.name || $t("menu_settings.variants") }}
              </h3>
              <div
                class="extra d-flex"
                v-for="(item,dit_index) in group.items.filter((i) => i.name)"
                :key="item.name+dit_index"
              >
                <button class="extra-btn">
                  <p class="w-75">
                    {{ item.name }}
                    <span class="color-grey" v-if="item.weight"
                      >({{ item.weight }} {{ $t(`units.${dish.unit}`) }})</span
                    >
                  </p>
                  <b class="price-group-item-price" v-if="item.price"
                    >{{ dish.base_price + item.price }}{{ currency.symbol }}</b
                  >
                </button>
              </div>
            </div>

            <div class="dish-modificators" v-else-if="hasModificatorGroups">
              <h3 class="extra-title">
                {{ group.name || $t("menu_settings.additions") }}
              </h3>
              <div
                class="extra d-flex"
                v-for="(item,iit_index) in group.items.filter((i) => i.name)"
                :key="item.name+iit_index"
              >
                <button class="extra-btn">
                  <p class="w-75">
                    {{ item.name }}
                    <span class="color-grey" v-if="item.weight"
                      >({{ item.weight }} {{ $t(`units.${dish.unit}`) }})</span
                    >
                  </p>
                  <b class="price-group-item-price" v-if="item.price"
                    >+{{ item.price }}{{ currency.symbol }}</b
                  >
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      editMode: false,
    };
  },
  props: {
    dish: Object,
    cache_nonce: Number,
  },

  methods: {
    showEditUI() {
      this.editMode = true;
    },
    onEditFinish() {
      this.editMode = false;
    },
  },

  computed: {
    breakedDescription() {
      if (!this.dish.description) return "";

      const value =
        this.isLocalizing && this.currentProductLocale.description
          ? this.currentProductLocale.description
          : this.dish.description;

      return value.split("\n").join("<br>");
    },
    isLocalizing() {
      return this.$store.getters["menu/isLocalizing"];
    },
    currentProductLocaleIndex() {
      return this.$store.getters["menu/currentProductLocaleIndex"];
    },
    currentProductLocale() {
      return this.$store.getters["menu/currentProductLocale"];
    },
    currency() {
      return this.$store.state.currency;
    },
    onlySinglePrice() {
      const variants_group = this.dish.price_groups.filter(
        (g) => g.single_select
      );
      return variants_group.length == 0;
    },
    firstPriceItem() {
      return this.dish.price_groups[0].items[0];
    },
    hasModificatorGroups() {
      const group = this.dish.price_groups.find((g) => !g.single_select);
      return !!group && group.items.length;
    },
  },
};
</script>

<style scoped>
.color-grey {
  color: #a4a3a1;
}

.space-scroll {
  overflow: auto !important;
  top: 0;
  z-index: 2;
  max-height: 56vh;
  border-radius: 1.5vh;
  position: relative;
  margin-top: 0;
  padding: 0;
}

.dish-card {
  width: 40vh;
  margin-right: 3vh;
  display: block;
  overflow: hidden;
  height: 80vh;
}
.dish-card-title {
  font-weight: 500;
  font-size: 3vh;
  margin-bottom: 0;
  color: #ffffff;
}

.dish-card-body {
  border-radius: 1vh;
}

.dish-desc-body {
  position: relative;
  max-height: 56vh;
  overflow: hidden;
  box-sizing: border-box;
}

.dish-card-scroll {
  overflow-y: auto;
  width: 100%;
  background: #1d1d1d;
  border-radius: 8px;
  min-height: 56vh;
  margin-top: 0;
  top: 23.5vh;
  position: relative;
  z-index: 5;
  padding: 3.3vh 2.3vh;
  box-sizing: border-box;
}

.dish-card img {
  width: 100%;
  position: absolute;
  top: 0;

  object-fit: cover;
  height: 26vh;
  border-radius: 1.5vh;
}

.dish-info h2 {
  font-weight: 500;
  font-size: 1.9vh;
  padding-right: 1vh;
  margin-top: -0.4vh;
  color: #ededed;
}

.about-dish {
  font-weight: 500;
  font-size: 1.6vh;
  line-height: 130.8%;
  padding-top: 1vh;

  color: #a4a3a1;
}
.price {
  position: relative;
  right: 0;
  top: -0.8vh;

  display: flex;
  align-items: center;
  text-align: right;

  font-weight: 500;
  font-size: 2.7vh;
  line-height: 1;

  color: #ededed;
}

.size {
  margin-top: 2vw;
}

.size button,
.extra button {
  width: 100%;

  background: transparent;
  border: 1px solid #908f8d;
  border-radius: 1vh;

  text-align: left;
  padding: 1.4vh;
  font-weight: 500;
  font-size: 1.9vh;
  outline: none;
  color: #1d1d1b;

  position: relative;
  margin-top: 1.7vh;
}

.extra-btn p {
  color: #908f8d;
}

.size button b,
.extra button b {
  position: absolute;
  right: 1.7vh;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 500;
  font-size: 1.7vh;
  /* line-height: 21px; */

  color: #1d1d1b;
}

.extra-title {
  font-weight: 500;
  font-size: 1.9vh;
  margin-top: 2.2vh;
  color: #ededed;
}

.price-group-item-price {
  color: #ededed !important;
}

/* .done:hover {
        background: #fff;
        color: #000;
    } */

.dish-name-header {
  display: flex;
  justify-content: space-between;
}
</style>
